$(document).ready(function(){
  var windowHeight = $(window).height();
  var titleHeight = $('.title').height();
  var windowWidth = $(window).width();
  var titleWidth = $('.title').width();
  var titlePosX = $('.title').offset().left;
  var titlePosY = $('.title').offset().top;
  $('.title').css('transform','translate('+(((windowWidth-titleWidth)/2)-titlePosX)+'px,'+(((windowHeight-titleHeight)/2))+'px)');
  $('.title').addClass('active');
  setTimeout(function(){
    $('.title').css('transition','600ms');
    $('.title').addClass('active2');
    $('header').addClass('active');
    $('.header_container').fadeIn(800);
    $('.sp_menu_btn').fadeIn(800);
    $('.overlay').fadeOut(800);
    $('.title').css('transform','translate(0,0)');
    $('.mv').css('z-index','1');
    $('section').css('z-index','3');
  },1400);
  setTimeout(function(){
    $('.title').css('z-index','0');
    $('.title').addClass('hidden');
    $('.header_logo_all').addClass('active');
  },2000);
});


$(window).on('load scroll resize',function(){
  var scroll = $(window).scrollTop();
  var windowHeight = $(window).height();
  var mvPos = $('.mv_right_inner').offset().top;
  var imgPos = $('.bottom_right').offset().top;
  var breakPoint = $('.break_point').offset().top;
  if (scroll > mvPos) {
    $('.mv').addClass('sp_hide');
  }else{
    $('.mv').removeClass('sp_hide');
  }
  if (scroll > (breakPoint - windowHeight - 5)) {
    $('.bottom_left').addClass('active');
  }else{
    $('.bottom_left').removeClass('active');
  }
});


$(function(){
  var pageLink=$('[href^="#"]');
  $(pageLink).click(function(){
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position=target.offset().top;
    $("html, body").animate({scrollTop:position}, 500, "swing");
    return false;
  });

  $('.sp_menu_btn').click(function(){
    $('header').toggleClass('open');
  });
  $('.header_container ul li a').click(function(){
    $('header').removeClass('open');
  });

  $(window).on('load scroll',function(){
    var scroll = $(window).scrollTop();
    var windowHeight = $(window).height();
    $('.scroll_action').each(function (){
        var This =$(this);
        var elemPos = This.offset().top;
        if(This.hasClass('bottom_action')){
          var triggerHeight = windowHeight*0.1;
        }else{
          var triggerHeight = windowHeight*0.4;
        }
        if (scroll > elemPos - windowHeight + triggerHeight){
          This.addClass('active');
        }
    });
  });

});
